var app = angular.module('leonardo');

var AttachmentService = function(BaseRestService, Upload, ConfigThemeService) {
  var service = new BaseRestService('attachments');

  service.validYardiFormats = ['pdf', 'jpg', 'jpeg'];

  service.post = function(name, file, link, available_for_account, action_item_id) {
    var available = null;
    if (angular.isArray(available_for_account)) {
      available = available_for_account;
    }
    else {
      available = (available_for_account ? available_for_account.split(',') : []);
    }
    if (link) {
      return Upload.upload({
        url: ConfigThemeService.generateURL('/api/2.0/attachments/'),
        arrayKey: '',
        data: {
          name: name,
          link: link,
          available_for_account: available,
          action_item_id: action_item_id
        }
      });
    }
    else {
      return Upload.upload({
        url: ConfigThemeService.generateURL('/api/2.0/attachments/'),
        arrayKey: '',
        data: {
          name: name,
          file: file,
          available_for_account: available,
          action_item_id: action_item_id
        }
      });
    }
  };

  service.delete = function(attachmentId) {
    return service.one(attachmentId).remove() // Assuming `one` fetches the specific attachment
      .then(response => response.data)
      .catch(error => {
        console.error("Error deleting attachment:", error);
        throw error; // Rethrow to handle it in the calling function
      });
  };
  
  service.getClassesAttachment = function (attachment) {
    if (isNull(attachment)) {
      return '';
    }
    var classes = '';
    if (attachment.document_folder && !isNull(attachment.document_folder.id)) {
      return 'folder';
    }
    if (attachment.link && (!attachment.document_file)) {
      return 'link';
    }
    var name = null;
    if (attachment.thumbnail) {
      name = attachment.thumbnail.toLowerCase();
    }
    else {
      if (attachment.file && angular.isString(attachment.file)) {
        name = attachment.file.toLowerCase();
      }
      else {
        name = attachment.name ? attachment.name.toLowerCase() : '';
      }
    }
    var array_url = name.split('.');
    switch (array_url[array_url.length-1]) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'svg':
      case 'bmp':
        classes = 'image';
        break;
      case 'mp4':
      case 'mkv':
      case 'wmv':
      case 'avi':
      case 'mov':
      case 'mpg':
      case 'mpeg':
        classes = 'video';
        break;
      case 'pdf':
        classes = 'pdf';
        break;
      case 'xls':
      case 'xlsx':
        classes = 'excel';
        break;
      case 'ppt':
      case 'pptx':
        classes = 'ppt';
        break;
      case 'txt':
      case 'doc':
      case 'docx':
        classes = 'text';
        break;
      case 'zip':
      case 'rar':
      case 'gzip':
        classes = 'zip';
        break;
      case 'mp3':
      case 'mid':
      case 'midi':
      case 'wav':
      case 'aac':
      case 'ac3':
      case 'm4a':
        classes = 'audio';
        break;
      default:
        classes = 'generic';
        break;
    }
    return classes;
  };

  service.linkTo = function(attachment, action_item_id) {
    var data = {
      name: attachment.name,
      action_item_id: action_item_id
    };
    if (attachment.document_folder) {
      data.document_folder = attachment.document_folder;
    }
    if (attachment.document_file) {
      data.document_file = attachment.document_file;
    }
    if (attachment.link) {
      data.link = attachment.link;
    }
    if (attachment.available_for_account) {
      data.available_for_account = angular.isArray(attachment.available_for_account) ?
        data.available_for_account : attachment.available_for_account.split(',');
    }

    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/attachments/'),
      data: data
    });
  };

  service.checkErrorSize = function (file) {
    var error = false;
    if (angular.isArray(file)) {
      angular.forEach(file, function (file_element) {
        if (!isNull(file_element) && file_element.size > 7.5E8) {
          error = true;
        }
      });
    }
    else if (!isNull(file) && file.size > 7.5E8) {
      error = true;
    }
    return error;
  };

  return service;
};

app.factory('AttachmentService', ['BaseRestService', 'Upload', 'ConfigThemeService', AttachmentService]);
